import { Box, BoxProps } from '@mui/material';
import { PropsWithChildren } from 'react';

export const SidenavRow = ({ children, sx, className, ...props }: PropsWithChildren<BoxProps>) => {
  return (
    <Box
      className={className}
      sx={{
        padding: '0 0.75rem',
        display: 'flex',
        alignItems: 'center',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
